export const CarouselType = {
  carousel: "carousel",
  outcomes: "outcomes",
  homepage: "homepage",
} as const;
